// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ISv3","title":"Header_title__THtGu","side":"Header_side__1cq5e"};